module.exports = __webpack_public_path__ + "media/newstyle/images/card-759b948cd068aaf0f6c0b65766682b5f.svg";